jQuery(document).ready(function ($) {
    jQuery('.faq-question').click(function ($) {
        $.preventDefault();

        var question = jQuery(this);
        var answer = question.next();

        question.toggleClass('open');
        answer.stop().slideToggle(300);
    });
});